import React, { Component } from 'react';
import ConnectionSuccessComponent from './connection-status/ConnectionSuccessComponent';
import { RootState } from '../../../redux/store';
import { changeConnection, changeConnectionIsUpdate, clearConnection } from '../../../redux/actions/ConnectionActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import ConnectionFailedComponent from './connection-status/ConnectionFailedComponent';
import ConnectionUnkownComponent from './connection-status/ConnectionUnkownComponent';
import RoleHelper from '../../../RoleHelper';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../custom/FormicaLabel';
import CustomPasswordInput from '../../custom/CustomPasswordInput';
import ComponentName from 'constant/ComponentName';
import LanguageUtil from '../../../util/LanguageUtil';

class ConnectionSqlComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const {
      connection: { connection },
    } = this.props;
    if (!connection) return null;
    return (
      <div className={'flex w-full h-full mt-2 border-t-[0.5px] border-b-[0.5px] border-[#E0E4E8] '}>
        <div className={'w-1/2 h-full flex flex-col border-r-[0.5px] border-[#E0E4E8] px-10 py-10 items-center '}>
          <div className={'flex flex-col gap-y-4 items-center justify-center w-full'}>
            <section className={'flex flex-col w-full'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.sql.hostname', defaultMessage: 'Host Name' })} className={'self-start'} />
              <FormicaInput
                onChange={this.onChangeValue}
                disabled={!RoleHelper.canEdit('Connection')}
                value={connection.hostname}
                id='hostname'
                placeholder={LanguageUtil.get({ id: 'pages.connection.sql.hostname', defaultMessage: 'Host Name' })}
                data-testid={`${ComponentName.CONNECTION}_hostname_input`}
              />
            </section>
            <section className={'flex flex-col w-full'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.sql.port', defaultMessage: 'Port' })} className={'self-start'} />
              <FormicaInput
                onChange={this.onChangeValue}
                disabled={!RoleHelper.canEdit('Connection')}
                value={connection.port}
                id='port'
                type='number'
                placeholder={LanguageUtil.get({ id: 'pages.connection.sql.port', defaultMessage: 'Port' })}
                data-testid={`${ComponentName.CONNECTION}_port_input`}
              />
            </section>
            <section className={'flex flex-col w-full'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.sql.database', defaultMessage: 'Dtabase Name' })} className={'self-start'} />
              <FormicaInput
                onChange={this.onChangeValue}
                disabled={!RoleHelper.canEdit('Connection')}
                value={connection.databaseName}
                id='databaseName'
                placeholder={LanguageUtil.get({ id: 'pages.connection.sql.database', defaultMessage: 'Database Name' })}
                data-testid={`${ComponentName.CONNECTION}_database_input`}
              />
            </section>
            <section className={'flex flex-col w-full'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.sql.username', defaultMessage: 'User Name' })} className={'self-start'} />
              <FormicaInput
                onChange={this.onChangeValue}
                disabled={!RoleHelper.canEdit('Connection')}
                value={connection.username}
                id='username'
                placeholder={LanguageUtil.get({ id: 'pages.connection.sql.username', defaultMessage: 'UserName' })}
                data-testid={`${ComponentName.CONNECTION}_username_input`}
              />
            </section>
            <section className={'flex flex-col w-full'}>
              <FormicaLabel label={LanguageUtil.get({ id: 'pages.connection.sql.password', defaultMessage: 'Password' })} className={'self-start'} />
              <CustomPasswordInput
                onChange={this.onChangeValue}
                disabled={!RoleHelper.canEdit('Connection')}
                value={connection.password}
                id='password'
                placeholder={LanguageUtil.get({ id: 'pages.connection.sql.password', defaultMessage: 'Password' })}
                data-testid={`${ComponentName.CONNECTION}_password_input`}
              />
            </section>
          </div>
        </div>
        <div className='w-1/2 h-full flex flex-col items-center justify-center'>{this.getStatusComponent()}</div>
      </div>
    );
  }

  private getStatusComponent = () => {
    const {
      connection: { connection },
    } = this.props;
    if (!connection) return null;
    if (connection.status == 'ACTIVE') return <ConnectionSuccessComponent />;
    if (connection.status == 'FAILED' || connection.status == 'INACTIVE') return <ConnectionFailedComponent />;
    return <ConnectionUnkownComponent />;
  };

  private onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      connection: { connection },
      changeConnection,
    } = this.props;
    connection[e.currentTarget.id] = e.currentTarget.value;
    changeConnection(connection);
  };
}

interface Props extends ReduxProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  connection: state.connection,
  isUpdate: state.connection.isUpdate,
});
const mapDispatchToProps = { changeConnectionIsUpdate, changeConnection, clearConnection, enterComponent, leaveComponent };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ConnectionSqlComponent);
